import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/tuffexProductCollectionWorkspaceCapability/domain/TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type TuffexProductCollectionWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.tuffexProductCollection> & {
    fixedUdoTemplates: {
        [TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey.collection]: {
            udoAdditionalColumnIds: {
                description: Uuid;
                displayName: Uuid;
                imageId: Uuid;
                isPublished: Uuid;
                slug: Uuid;
                sortOrder: Uuid;
            };
        };
        [TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey.membership]: {
            udoAdditionalColumnIds: {
                collectionId: Uuid;
                productCatalogueId: Uuid;
                sortOrder: Uuid;
                uniqueKey: Uuid;
            };
        };
    };
};

export const tuffexProductCollectionWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey.collection]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                description: uuidZodValidator,
                displayName: uuidZodValidator,
                imageId: uuidZodValidator,
                isPublished: uuidZodValidator,
                slug: uuidZodValidator,
                sortOrder: uuidZodValidator,
            }),
        }),
        [TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey.membership]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                collectionId: uuidZodValidator,
                productCatalogueId: uuidZodValidator,
                sortOrder: uuidZodValidator,
                uniqueKey: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<TuffexProductCollectionWorkspaceCapabilityUdoBindings>;
